// Percorso file: src/utils/exportGiocatori.js
//
// L'EXPORT DEI GIOCATORI in .xlsx (cantiere TEAMS-LIST / L2), condiviso dai
// due bottoni della pagina Teams (src/pages/TeamsList.jsx): «Export all
// players» sull'elenco, «Export players» sul dettaglio di squadra.
//
// Le righe arrivano GIÀ COMPOSTE da `GET /teams-export` (backend/server.js):
// la rosa, il contatto primario e la proiezione si decidono sul server. Qui
// si fa soltanto la forma del file: l'ordine, la colonna «Category» e la
// scrittura.
//
// ⚠️ LA CATEGORIA NON SI RISCRIVE: si chiede a `categoriaAnagrafica`
// (utils/categoria.js, sede unica), con l'anno dell'export. Non
// determinabile → cella vuota, come la pastiglia che tace.
//
// La scrittura è il pattern già in produzione in components/ClubFinance.jsx:
// `import("xlsx")` pigro → json_to_sheet → book_new → book_append_sheet →
// writeFile.

import { categoriaAnagrafica } from "./categoria";
import { normalizza } from "./roleUtils";

/** Le colonne, nell'ordine: sono anche l'intestazione del foglio. */
export const COLONNE_EXPORT_GIOCATORI = [
  "First Name",
  "Last Name",
  "Team",
  "Category",
  "Parent / contact",
  "Phone",
  "Email"
];

const testo = (valore) => (valore == null ? "" : String(valore));

/** Ordine del file: squadra, poi cognome e nome — il metro della pagina
 *  (`normalizza(a).localeCompare(normalizza(b))`). */
const perSquadraECognome = (a, b) =>
  normalizza(testo(a?.team)).localeCompare(normalizza(testo(b?.team))) ||
  normalizza(`${testo(a?.lastName)} ${testo(a?.firstName)}`).localeCompare(
    normalizza(`${testo(b?.lastName)} ${testo(b?.firstName)}`)
  );

/**
 * Dalle righe della rotta alle righe-oggetto del foglio, con le chiavi
 * nell'ordine di `COLONNE_EXPORT_GIOCATORI`. Celle mancanti → "".
 * Funzione pura: nessuna rete, nessun file.
 */
export function righeExportGiocatori(rows, anno) {
  return (Array.isArray(rows) ? rows : [])
    .filter(Boolean)
    .slice()
    .sort(perSquadraECognome)
    .map((r) => ({
      "First Name": testo(r.firstName),
      "Last Name": testo(r.lastName),
      Team: testo(r.team),
      Category: categoriaAnagrafica(r, anno) || "",
      "Parent / contact": testo(r.contactName),
      Phone: testo(r.phone),
      Email: testo(r.email)
    }));
}

/** Un nome di squadra reso innocuo per il filesystem. */
export function nomeFilePulito(valore) {
  const pulito = String(valore || "")
    .trim()
    .replace(/[^A-Za-z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return pulito || "team";
}

/**
 * Scrive il file. Torna il numero di righe scritte; con 0 righe NON scrive
 * nulla (il chiamante avvisa «No players to export»).
 */
export async function esportaGiocatori(rows, anno, filename) {
  const righe = righeExportGiocatori(rows, anno);
  if (righe.length === 0) return 0;

  const XLSX = await import("xlsx");

  const worksheet = XLSX.utils.json_to_sheet(righe, {
    header: COLONNE_EXPORT_GIOCATORI
  });
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Players");

  XLSX.writeFile(workbook, filename);

  return righe.length;
}
